/**
 * @deprecated This object is deprecated and will be removed in future.
 * Use LeadSystemAttributeSchemaName instead
 */
export const SYSTEM_ATTRIBUTE_SCHEMA_NAMES = {
  firstName: 'FirstName',
  lastName: 'LastName',
  fullName: 'FullName',
  email: 'EmailAddress',
  leadScore: 'Score',
  owner: 'OwnerId',
  leadStage: 'ProspectStage',
  leadSource: 'Source',
  leadLocation: 'PhotoUrl',
  leadMobile: 'Phone',
  createdOn: 'CreatedOn',
  createdBy: 'CreatedById',
  modifiedOn: 'UpdatedOn',
  modifiedBy: 'UpdatedById',
  leadAge: 'LeadAge',
  ownerEmail: 'OwnerIdEmailAddress',
  lastActivityDate: 'ProspectActivityDate_Max',
  engagementScore: 'EngagementScore',
};

export const ACTIVITY_ATTRIBUTE_SCHEMA_NAMES = {
  owner: 'Owner',
};

export const DEFAULT_VISIBLE_COLUMNS = [
  SYSTEM_ATTRIBUTE_SCHEMA_NAMES.email,
  SYSTEM_ATTRIBUTE_SCHEMA_NAMES.owner,
  SYSTEM_ATTRIBUTE_SCHEMA_NAMES.modifiedOn,
];

export const FIELDS_WITH_USER_REFERENCE = [
  SYSTEM_ATTRIBUTE_SCHEMA_NAMES.owner,
  SYSTEM_ATTRIBUTE_SCHEMA_NAMES.modifiedBy,
  SYSTEM_ATTRIBUTE_SCHEMA_NAMES.createdBy,
];

export const ACTIVITY_FIELDS_WITH_USER_REFERENCE = [
  ACTIVITY_ATTRIBUTE_SCHEMA_NAMES.owner,
];

export const LEAD_FLAT_ATTRIBUTE_MAPPING = {
  [SYSTEM_ATTRIBUTE_SCHEMA_NAMES.owner]: 'owner',
  [SYSTEM_ATTRIBUTE_SCHEMA_NAMES.modifiedBy]: 'updatedBy',
  [SYSTEM_ATTRIBUTE_SCHEMA_NAMES.createdBy]: 'createdBy',
} as const;

export type LeadFlatAttributeTypes = typeof LEAD_FLAT_ATTRIBUTE_MAPPING[keyof typeof LEAD_FLAT_ATTRIBUTE_MAPPING];
